// @mui
import {
  Box,
  Card,
  CardContent,
  Typography,
  Stack,
} from '@mui/material';
// hooks
import useResponsive from "../../hooks/useResponsive";

// ----------
const WEEK_TITLE = ["일", "월", "화", "수", "목", "금", "토"];

export default function SentReselected3WayTime({ offer }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h4" gutterBottom>
        회사에게 미팅 가능 시간을 다시 전달 해드릴게요.
      </Typography>
      <Typography sx={{ mb: 3 }} variant={smUp ? "body1" : "body2"}>
        사전 미팅 일정이 확정되면 카카오톡으로 안내해드리겠습니다.
      </Typography>
      <Card
        sx={{
          mb: 3,
          border: '1px solid'
      }}
      >
        <CardContent sx={{ p: 3 }}>
          <Typography variant="h5" sx={{ mb: 3 }}>
            사전 미팅 가능 시간 변경 완료
          </Typography>

          <Box sx={{ p:3, backgroundColor: 'grey.200', borderRadius: 1 }}>
            <Stack spacing={0.5}>
            {offer.crew_3way?.length > 0 && offer.crew_3way?.sort((a, b) => a.date > b.date ? 1 : -1)?.map((pt, i) => (
              <Typography key={i}>
                <b>{WEEK_TITLE[new Date(pt.date).getUTCDay()]}요일({Number.parseInt(pt.date.slice(8))}일)</b> {pt.intervals?.map((item) => `${Number.parseInt(item.start.slice(0, 2))}시`).join(', ')}
              </Typography>
            ))}
            </Stack>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
};
